/**
 * devLog — Production-safe logging utility for ColoBongo.
 *
 * console.info / console.warn calls are silenced in production builds.
 * console.error is always forwarded (real errors should surface everywhere).
 */

const IS_DEV = process.env.NODE_ENV !== 'production';

export const devLog = {
  info: IS_DEV ? console.info.bind(console) : () => {},   // eslint-disable-line no-console
  warn: IS_DEV ? console.warn.bind(console) : () => {},   // eslint-disable-line no-console
  error: console.error.bind(console),                      // eslint-disable-line no-console
};
